import { render, staticRenderFns } from "./radish-bind-dialog.vue?vue&type=template&id=df1c92bc"
import script from "./radish-bind-dialog.vue?vue&type=script&lang=js"
export * from "./radish-bind-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports